import { activityEntrySchema, paginated } from '@hearth/shared';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ActivityTable } from '@/components/activity-table';
import { Pagination } from '@/components/pagination';
import { QueryState } from '@/components/query-state';
import { Card, CardContent } from '@/components/ui/card';
import { apiRequest } from '@/lib/api';

export const Route = createFileRoute('/_app/server/$server/activity')({
  validateSearch: (s: Record<string, unknown>): { page?: number } =>
    Number(s.page) > 1 ? { page: Number(s.page) } : {},
  component: ServerActivity,
});

function ServerActivity() {
  const { server } = Route.useParams();
  const { page = 1 } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const activity = useQuery({
    queryKey: ['server', server, 'activity', page],
    queryFn: ({ signal }) =>
      apiRequest(`/api/client/servers/${server}/activity?page=${page}`, {
        schema: paginated(activityEntrySchema),
        signal,
      }),
  });
  return (
    <QueryState query={activity}>
      {({ data, meta }) => (
        <Card>
          <CardContent className="grid gap-4">
            <ActivityTable entries={data} />
            <Pagination
              page={meta.page}
              totalPages={meta.totalPages}
              total={meta.total}
              onPageChange={(p) => void navigate({ search: p > 1 ? { page: p } : {} })}
            />
          </CardContent>
        </Card>
      )}
    </QueryState>
  );
}
